<script lang="ts">
  import { onMount } from 'svelte';
  import { ActionType, useDispatch } from './Store';

  const dispatch = useDispatch();

  let main: HTMLDivElement;

  const scrollEvent = () => {
    dispatch({
      type: ActionType.setMainToTopInPx,
      payload: main.getBoundingClientRect().top || null,
    });
  };

  onMount(() => {
    scrollEvent();
    document.addEventListener('scroll', scrollEvent);
    return () => {
      document.removeEventListener('scroll', scrollEvent);
    };
  });
</script>

<div bind:this={main} class="main main-raised overflowHidden maxWidth">
  <slot />
</div>

<style>
  .overflowHidden {
    overflow: hidden;
  }

  .maxWidth {
    max-width: 1280px;
    margin: -60px auto;
  }
</style>
